'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import gsap from 'gsap'
import ParallaxFx from '../fx/ParallaxFxVert'
import RevealFx from '../fx/RevealFx'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--civiArticle'
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, Env.introBaseDelay);
        this.shareActions(this.view)
        this.fx()
        this.reveal = new RevealFx(this.view)
    }

    fx()
    {
      const instance = new ParallaxFx(this.view)
      instance.animate()

      const $itemsReveal = this.view.querySelectorAll('.jsRevealItem--view')
      for(let $item of $itemsReveal) {
        const instance = new ItemRevealFx($item)
        instance.animate()
      }
    }

    intro()
    {
      const $intro = this.view.querySelector('.jsIntro')
      const $elementsA = [$intro.querySelectorAll('.jsFxA')]
      const $elementsB = [$intro.querySelectorAll('.jsFxB'),this.view.querySelector('.jsChapter')]
      const tl = gsap.timeline()

      tl.add([
        gsap.fromTo($elementsA , { autoAlpha: 0 },{ autoAlpha: 1, ease:'cubic.out' , duration:1 , stagger:.2 }),
        gsap.fromTo($elementsB , { autoAlpha: 0, y: 20 },{ autoAlpha: 1 , y:0, ease:'cubic.out' , duration:1 , stagger:.2 }),
      ])
    }

    shareActions()
    {
      this.$triggers = this.view.querySelectorAll('.jsTriggerShare')
      for (let $trigger of this.$triggers) {
        $trigger.addEventListener('click',()=>{
          const getUrl = $trigger.getAttribute("data-url")
          Env.framework.toolbox.openCenteredWindow({
            url: getUrl,
            width: 600,
            height: 600
          }).focus()
        })
      }
    }

}

page = Barba.BaseView.extend({
    namespace: 'civiArticle',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
